import {NgModule} from '@angular/core';
import {ShipmentsComponent} from '@modules/shipments/shipments.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {MaterialModule} from '@modules/material/material.module';
import {AgmCoreModule} from '@agm/core';
import {TranslateModule} from '@ngx-translate/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SharedModule} from '@modules/shared/shared.module';
import {ShipmentsRoutingModule} from '@modules/shipments/shipments-routing.module';
import {SavedShipmentsComponent} from '@modules/shipments/components/saved-shipments/saved-shipments.component';
import {BookedShipmentsComponent} from '@modules/shipments/components/booked-shipments/booked-shipments.component';
import {OngoingShipmentsComponent} from '@modules/shipments/components/ongoing-shipments/ongoing-shipments.component';
import {DeliveredShipmentsComponent} from '@modules/shipments/components/delivered-shipments/delivered-shipments.component';
import {ShipmentStatusComponent} from '@modules/shipments/components/shipment-status/shipment-status.component';
import {ShipmentInfoComponent} from '@modules/shipments/components/shipment-info/shipment-info.component';
import {AdditionalCostsComponent} from '@modules/shipments/components/additional-costs/additional-costs.component';
import {ShipmentTitleComponent} from '@modules/shipments/components/shipment-title/shipment-title.component';
import {ShipmentTableComponent} from '@modules/shipments/components/shipment-table/shipment-table.component';
import {ShipmentListComponent} from '@modules/shipments/components/shipments-list/shipment-list.component';
import {CommonModule} from '@angular/common';
import {ShipmentImportComponent} from '@modules/shipments/components/shipment-import/shipment-import.component';
import {TrackComponent} from '@modules/shipments/components/track/track.component';

@NgModule({
  imports: [
    // angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // libraries
    MaterialModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDL4eB6J10hcVcClWa-UrjvvqBAbMNIujo',
      libraries: ['places']
    }),
    TranslateModule.forChild(),
    FontAwesomeModule,
    // custom
    SharedModule,
    ShipmentsRoutingModule
  ],
  providers: [
    // FontAwesomeService
  ],
  declarations: [
    // components
    ShipmentListComponent,
    ShipmentTableComponent,
    SavedShipmentsComponent,
    BookedShipmentsComponent,
    OngoingShipmentsComponent,
    DeliveredShipmentsComponent,
    ShipmentsComponent,
    ShipmentInfoComponent,
    AdditionalCostsComponent,
    ShipmentStatusComponent,
    ShipmentTitleComponent,
    ShipmentImportComponent,
    TrackComponent
  ],
  exports: [
    ShipmentsComponent,
  ]
})

export class ShipmentsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/shipments/shipments.module.ts